import React, { useEffect, useState } from 'react';
import './index.scss';

import logo from "../../assets/img/logo-bg.png";
import Button from "../../common/Button";
import axios from 'axios';
import MSGDialogue from '../../components/Dialogue';
import { APIurl, rootUrl, callcookie, getCookie } from '../../App';
import { Container } from 'react-bootstrap';

export default function Login() {

  useEffect(() => {
    if (getCookie("eatradeuser") != null) {
      // eslint-disable-next-line no-restricted-globals
      location.href = rootUrl;
    }
  }, []);

  /* ================= STATE ================= */
  const [username, setUsernameValue] = useState("");
  const [password, setPasswordValue] = useState("");

  const [err_username, setUsernameError] = useState("");
  const [err_pasword, setPasswordError] = useState("");

  const [loginmsg, setLogingmsg] = useState("");
  const [colors, setColors] = useState("");
  const [logging, setLogging] = useState(false);

  /* ================= LOGIN PROCESS ================= */
  const process = () => {

    let ok = true;

    if (!username.trim()) {
      setUsernameError("Username cannot be empty");
      ok = false;
    } else {
      setUsernameError("");
    }

    if (!password.trim()) {
      setPasswordError("Password cannot be empty");
      ok = false;
    } else {
      setPasswordError("");
    }

    if (!ok) return;

    axios.post(APIurl, {
      username,
      pasword: password,
      cmd: "login"
    })
    .then((response) => {

      const res = response.data;

      if (!res.success) {
        setLogingmsg(res.data);
        setColors("text-white bg-danger");
      } else {
        setLogingmsg("Login successful");
        setColors("text-white bg-success");

        // store session cookie
        callcookie("eatradeuser", res.data[0], 1);

        // store mentor email for later (license keys)
        localStorage.setItem("email", username);

        // store user type (owner)
        localStorage.setItem("userType", res.data[1]);


        setTimeout(() => {
          // eslint-disable-next-line no-restricted-globals
          location.href = rootUrl;
        }, 1000);
      }

      setLogging(true);
    })
    .catch((error) => {
      console.error(error);
      setLogingmsg("Error encountered");
      setColors("text-white bg-danger");
      setLogging(true);
    });
  };

  /* ================= UI ================= */
  return (
    <>
      {logging && (
        <MSGDialogue
          msg={loginmsg}
          id="msg1"
          colors={colors}
        />
      )}

      <Container fluid className='p-3 bg-white h-100'>
        <Button title="Home" active="btn-deactive my-3 font-weight-bold" path="/" />

        <div className='w-100 login-logo'>
          <img src={logo} alt="logo" />
        </div>

        <div className='login-container mx-auto my-3 p-3 bg-secondary rounded animate__animated animate__fadeInDown'>
          <div className="text-white h3 text-center">Admin Login</div>
          <hr />

          <div className='form-group my-2 mx-1'>
            <input
              className='form-control'
              placeholder='Enter Username'
              value={username}
              onChange={(e) => setUsernameValue(e.target.value)}
            />
            <span className='text-danger'>{err_username}</span>
          </div>

          <div className='form-group my-2 mx-1'>
            <input
              className='form-control'
              placeholder='Enter Password'
              type="password"
              value={password}
              onChange={(e) => setPasswordValue(e.target.value)}
            />
            <span className='text-danger'>{err_pasword}</span>
          </div>

          <Button
            title="Sign In"
            active="btn-deactive my-3"
            action={process}
          />
        </div>
      </Container>
    </>
  );
}
